<!--
Copyright (c) 2022-2025 Antmicro <www.antmicro.com>

SPDX-License-Identifier: Apache-2.0
-->

<!-- eslint-disable max-len -->
<template>
     <svg class="__title-icon" width="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
        <circle cx="10" cy="10" r="4" />
    </svg>
</template>

<style lang="scss" scoped>
.__title-icon circle {
    fill: $gray-200;
}
</style>
